import { treaty } from "@elysiajs/eden";

import { type API, onResponse } from "@ca/api";

export const client = treaty<API>(window.location.origin, {
	headers: {
		"x-classa-client": "web",
	},
	onResponse,
});
